import { apiURL, baseURL, sentryUrl, imageBaseURL, xFunctionsKey, ocpApimSubscriptionKey, syncfusionLicenseKey, stripePublicKey } from 'helpers/config';

const params = {
  development: {
    apiUrl: apiURL + `/api/v1`,
    baseUrl: baseURL,
    imageBaseURL: imageBaseURL,
    xFunctionsKey: xFunctionsKey,
    ocpApimSubscriptionKey: ocpApimSubscriptionKey,
    syncfusionLicenseKey: syncfusionLicenseKey,
    stripePublicKey: stripePublicKey,
    sentryUrl: sentryUrl,
  },
  production: {
    apiUrl: apiURL,
    baseUrl: baseURL,
    imageBaseURL: imageBaseURL,
    xFunctionsKey: xFunctionsKey,
    ocpApimSubscriptionKey: ocpApimSubscriptionKey,
    syncfusionLicenseKey: syncfusionLicenseKey,
    stripePublicKey: stripePublicKey,
    sentryUrl: sentryUrl,
  },
  staging: {
    apiUrl: apiURL,
    baseUrl: baseURL,
    imageBaseURL: imageBaseURL,
    xFunctionsKey: xFunctionsKey,
    ocpApimSubscriptionKey: ocpApimSubscriptionKey,
    syncfusionLicenseKey: syncfusionLicenseKey,
    stripePublicKey: stripePublicKey,
    sentryUrl: sentryUrl,
  },
};

export default params[process.env.NODE_ENV || 'development'];
